import { mapGetters } from 'vuex'

export const agenciesMixin = {
  data() {
    return {
      active: [],
      agencyIds: [],
      match: false,
      agencySelectedIn: null,
      agencySelectedIds: []
    }
  },
  watch: {
    agencySelected(newValue) {
      if (newValue === null) this.active = []
    }
  },
  computed: {
    ...mapGetters(['agencySelected'])
  },
  methods: {
    recursiveSearch(obj) {
      for (const children in obj) {
        if (this.match) break

        if (typeof obj[children] === 'object' && obj[children] !== null) {
          if (obj[children].id === this.active[0]) {
            this.agencySelectedIn = obj[children]
            this.match = true
            break
          } else this.recursiveSearch(obj[children])
        }
      }
      return this.agencySelectedIn
    },
    recursiveSearchIn(obj) {
      for (const children in obj) {
        if (typeof obj[children] === 'object' && obj[children] !== null) {
          if (obj[children].id !== undefined) this.agencyIds.push(obj[children].id)
          this.recursiveSearchIn(obj[children])
        }
      }
    },
    recursiveSearchIds(obj) {
      for (const children in obj) {
        if (typeof obj[children] === 'object' && obj[children] !== null) {
          if (obj[children].id !== undefined) this.agencySelectedIds.push(obj[children].id)
          this.recursiveSearchIds(obj[children])
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/agenciesMixin.js